import { Subject } from 'rxjs';

const subject = new Subject();

export const megaMenuSerivice = {
    openMegaMenu: (open) => subject.next(open),
    handleOpen: () => subject.asObservable(),
};
